import clsx from 'clsx'
import { FormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { getSubcontractorInitialValues } from './helpers/get-subcontractor-initial-values'
import styles from './subcontractor-params.module.scss'
import { SubcontractorParamsValidationSchema } from './validators/subcontractor-params-validation.schema'
import { useFormik } from '../../../../../common/hooks/formik'
import { PureButton } from '../../../../../common/ui/pure-button/pure-button'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { PureTextArea } from '../../../../../common/ui/pure-text-area/pure-text-area'
import { SubcontractorFormValues } from '../../types/milestone-transfer.types'

type SubcontractorParamsType = {
  onSubmit: (values: SubcontractorFormValues) => void
}

export const SubcontractorParams = ({ onSubmit }: SubcontractorParamsType) => {
  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: getSubcontractorInitialValues(),
    validationSchema: SubcontractorParamsValidationSchema(),
    enableReinitialize: true,
    onSubmit: () => {},
  })

  const handleSubmit = async () => {
    await formik.submitForm()
    const errors = await formik.validateForm()
    if (!Object.keys(errors).length) {
      onSubmit(formik.values as SubcontractorFormValues)
    }
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <div className={clsx(styles.wrapper, 'h-100 pt-3 px-2')}>
        <div className={clsx(styles.formWrapper)}>
          <h6>
            <span className="ml-1">{t('milestoneTransfer.subcontractor.header')}</span>
          </h6>
          <hr />
          <div className="mt-1 px-2 d-flex flex-column justify-content-between">
            <div>
              <PureInput
                {...formik.getFieldProps('email')}
                error={formik.errors.email}
                label={t('milestoneTransfer.subcontractor.emailLabel')}
                placeholder={t('milestoneTransfer.subcontractor.emailPlaceholder')}
                size="small"
              />
              <div className="mt-2">
                <PureTextArea
                  {...formik.getFieldProps('comment')}
                  error={formik.errors.comment}
                  label={t('milestoneTransfer.subcontractor.commentLabel')}
                  placeholder={t('milestoneTransfer.subcontractor.commentPlaceholder')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles.buttonsWrap, 'p-2 d-flex justify-content-between align-items-center')}>
          <PureButton
            onClick={handleSubmit}
            size="small"
            type="primary"
          >
            {t('common.transfer')}
          </PureButton>
        </div>
      </div>
    </FormikContext.Provider>
  )
}
